






import { Component, Vue } from 'vue-property-decorator'
import UserList from '@/components/user/UserList.vue'

@Component({
  components: {
    UserList
  }
})
export default class User extends Vue {}
